module.exports = __webpack_public_path__ + "img/up.1bdde753.svg";